import React from 'react';
import { Icon } from './Icon.js';
export const IconDatabase = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 5V19C3 20.6569 7.02944 22 12 22C16.9706 22 21 20.6569 21 19V5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5C3 3.34315 7.02944 2 12 2C16.9706 2 21 3.34315 21 5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconDatabase.js.map